<template>
<div>
    <div class="mcc-page-header">
        <div>
            <div class="mu-d-flex">
                <h1 class="mu-mb-00">Process errors</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">
                        <p class="mu-mb-00">
                            {{ helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Process engine</li>
                    <li>Process errors</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div class="mcc-card__body">
                        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="submitDialog($event)" title="Process Error Filters">
                           
                                <div class="mcc-row">
                                    <form id="formIdd">
                                        <div>
                                            <div class="mcc-segmented-buttons mcc-segmented-buttons--sm">
                                                <fieldset class="mfc-fieldset">
                                                    <legend class="mfc-label">
                                                        Process Status
                                                    </legend>
                                                    <div class="mcc-segmented-buttons__list" ref="radioRef" name="status-radioGroup" id="status-radioGroup">
                                                        <input type="checkbox" value="running" id="running" name="running" @click="statusRef = $event.target.value" :checked="statusRef == 'running'">
                                                        <label class="mcc-segmented-buttons__button" for="running">
                                                            <span class="mcc-segmented-buttons__label">Open</span>
                                                        </label>
                                                        <input type="checkbox" value="completed" id="completed" name="completed" @click="statusRef = $event.target.value" :checked="statusRef == 'completed'">
                                                        <label class="mcc-segmented-buttons__button" for="completed">
                                                            <span class="mcc-segmented-buttons__label">Completed</span>
                                                        </label>
                                                        <input type="checkbox" name="all" value="all" id="all" @click="statusRef = $event.target.value" :checked="statusRef == 'all'">
                                                        <label class="mcc-segmented-buttons__button" for="all">
                                                            <span class="mcc-segmented-buttons__label">All</span>
                                                        </label>
                                                    </div>
                                                </fieldset>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            
                        </Drawer>
                        <div class="mcc-col">
                            <div style="position:relative">
                                <div v-if="!updateCall" class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mcc-card">
                                    <div class="mcc-card__body">
                                        <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                            <button class="mcc-button mcc-button--outline  mcc-button--sm" @click="$refs.customFilter.open()">
                                                <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                                <span class="mcc-button__label">Filters {{externalSystemNameRef ? ' (1)' : '(1)'}}</span>
                                            </button>
                                        </div>
                                        <mcc-data-table ref="processErrorsTable" id="processErrorsTableId"></mcc-data-table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--info mcc-dialog--xs"  ref="processFailureDetailDialog" id="processFailureDetailDialog">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Process Failure Details</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeProcessFailureDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div ref="detailedErrorMessage" id="detailedErrorMessage" v-html="errorDetail"></div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--info" @click="closeProcessFailureDialog()">Close</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" ref="deleteEntityModal" id="deleteEntityModal">
            <section>
                <div class="mcc-dialog__header">
                    <h2 class="h4">Delete error</h2>
                    <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteEntityModal.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                </div>
                <div class="mcc-dialog__body">
                    <div class="mcc-row">
                        <div class="mcc-col">
                            {{removeProcessErrorMsg}}?
                        </div>
                    </div>
                </div>
                <div class="mcc-dialog__footer">
                    <div class="mcc-button-group mcc-button-group--spaced">
                        <button type="button" class="mcc-button mcc-button--outline" @click="$refs.deleteEntityModal.close()">No</button>
                        <button type="button" class="mcc-button mcc-button--danger" @click="handleDeleteErrDialogClose()">Yes</button>
                    </div>
                </div>
            </section>
        </dialog>
    </div>
</div>
</template>

<script>
import constantMessages from "../../../messages";
import Table from "@advanced/component-mosaic-table";
import ProcessErrorAPI from "../../../services/ProcessErrorAPI";
import Utils from "../../../script_utils";
import Drawer from '../../common/Drawer.vue';
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';
import {
    EventBus
} from "../../../services/event-bus";
export default {
    name: "ProcessErrorList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["processengine.processerrors.list"],
            showHelpText: false,
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            processErrors: {},
            updateDialog: false,
            tableObj: null,
            currentPageSize: 10,
            updateCall: true,
            statusRef: "running",
            statusType: "running",
            errorDetail: "",
            removeProcessErrorMsg: "",
            removeProcessErrorId: ""
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.getProcessErrorsData();
    },
    methods: {
        closeProcessFailureDialog()
        {
            this.$refs.processFailureDetailDialog.close()
            this.errorDetail = ''
        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.updateCall = false;
            this.statusType = this.statusRef;
            this.getProcessErrorsData();
            this.initProcessErrorsTable();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        getProcessErrorsData() {
            let self = this;
            let queryString = "";
            if (self.statusType == "running") {
                queryString = "finished=false";
            } else if (self.statusType == "completed") {
                queryString = "finished=true";
            }
            ProcessErrorAPI.getAllProcessErrors(queryString).then(result => {
                self.processErrors = {
                    totalCount: 0,
                    data: []
                };
                if (result.data != null) {
                    result.data.forEach(element => {
                        element['createdDateString'] = element['created'] != null ?
                            Utils.getMomentDateString(element['created']) : '';
                        element["Process name"] = element['processName'];
                    });
                    self.processErrors.data = result.data;
                }
                self.processErrors.data.forEach(function (item, i) {
                    if (item.processName == '') {
                        item.processName = null;
                    }
                });
                self.initProcessErrorsTable();
                self.updateCall = true;
            });
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
        },
        resetFilter() {
            this.updateCall = false;
            this.statusRef = "running";
            this.statusType = "running";
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.getProcessErrorsData();
            this.initProcessErrorsTable();
        },
        handleShowErrorDetail() {
            let self = this;
            setTimeout(() => {
                $(self.$refs.detailedErrorMessage).jsonFormatter();
            }, 0);
        },
        handleDeleteErrDialogClose() {
            let self = this;
            self.$refs.deleteEntityModal.close()
                ProcessErrorAPI.removeProcessError(this.removeProcessErrorId).then(result => {
                    self.processErrors.data.forEach(function (item, i) {
                        if (item.id == self.removeProcessErrorId) {
                            self.processErrors.data.splice(i, 1);
                            self.processErrors.totalCount = self.processErrors.data.length;
                        }
                    });
                    EventBus.$emit('success-notification', {
                        "msg": constantMessages.MESSAGES["processerror.delete.success"]
                    });
                    self.initProcessErrorsTable();
                });
        },
        initProcessErrorsTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            const filesTable = document.querySelector('#processErrorsTableId');
            window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process errors found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                debounceTime: 1000,
                schema: {
                    properties: {
                        processName: {
                            type: "string",
                            title: "Process name",
                            sortable: true,
                            columnSearch: false,
                            template: '<a class="name-link" data-procId="{{processId}}">{{processName}}</a>',
                        },
                        taskName: {
                            type: "string",
                            title: "Task",
                            sortable: true,
                            columnSearch: false
                        },
                        created: {
                            type: "string",
                            title: "Created",
                            template: '<div class="dateTemplate"><u>{{createdTime}}</u><div>{{createdDateString}}</div></div>',
                            sortable: true,
                            columnSearch: false
                        },
                        actions: {
                            type: "object",
                            title: "Actions",
                            properties: {
                                viewErrorAction: {
                                    type: "string",
                                    format: "button",
                                    title: "View error",
                                    icon: "view",
                                    color: "success",
                                    iconOnly: false
                                },
                                deleteAction: {
                                    type: "string",
                                    format: "button",
                                    title: "Delete",
                                    icon: "trash",
                                    color: "danger",
                                    iconOnly: true
                                }
                            }
                        }
                    }
                },
                sortHeader: 'created',
                sortDirection: 'desc',
                data: () => {
                    return self.processErrors.data;
                },
                onAction: (table, action, obj) => {
                    let rowData = obj[0].rowData;
                    if (action == "viewErrorAction") {
                        self.errorDetail = "";
                        self.errorDetail = rowData.errorMessage;
                        self.$refs.processFailureDetailDialog.show();
                        self.handleShowErrorDetail()
                    } else if (action == "deleteAction") {
                        self.removeProcessErrorMsg = "";
                        self.removeProcessErrorId = "";
                        if (rowData.processName != null && rowData.processName != "") {
                            self.removeProcessErrorMsg = "Are you sure you want to remove error : " + rowData.processName;
                        } else {
                            self.removeProcessErrorMsg = "Are you sure you want to remove error";
                        }
                        self.removeProcessErrorId = rowData.id;
                        self.$refs.deleteEntityModal.show();
                    } else {
                        
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        updateTemplate() {
            let self = this;
            self.$refs.processErrorsTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let procId = $(targetEle).attr("data-procId");
                            self.$router.push(
                                self.CONTEXT_PATH + "/processengine/processes/processinstance/" + procId + "/all"
                            );
                        }
                    });
                });
        }
    }
};
</script>

<style scoped>
#detailedErrorMessage {
    max-height: 400px;
    overflow: auto;
}
</style>
